import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Loader from 'react-js-loader'
import { dateFormat } from '../../utils/dateTime'
// import loader from '../icons/loder.gif'
import loader from "../challengeManagement/loder.gif"
import playSound from "./accept.mp3";
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net';
import { apiRequest } from '../../store/allApi'

export default function Conflict() {
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API
  const nodeMode = process.env.NODE_ENV
  const [loading, setLoading] = useState(false)

  if (nodeMode === 'development') {
    var baseUrl = beckendLocalApiUrl
  } else {
    baseUrl = beckendLiveApiUrl
  }

  const [challenge, setchallenge] = useState()
  const permission1 = localStorage.getItem("PData");
  const pdata = JSON.parse(permission1);
  const meedata = localStorage.getItem("uData");
  const userData = JSON.parse(meedata);
   const SiteData = localStorage.getItem("siteSetting");
  const Setting = JSON.parse(SiteData);
  const Allchallenge = async () => {
    // setLoading(true) 
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      const res = await apiRequest(`challange/conflict_challange`, "GET", null, headers)
      if (res.data) {
        setLoading(false)
        setchallenge(res.data)
        $('table').dataTable()
      }
    } catch (e) {
      setLoading(false);
    }
    finally {
    }
  }

  const CancelGame = async id => {
    const confirm = window.confirm('are you sure to cancel')

    if (confirm == true) {
      const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`
      }
      axios
        .patch(
          baseUrl + `challange/Cancel/${id}`,
          { Cancelled_by: access_token },
          { headers }
        )
        .then(res => {
          Allchallenge()
        })
    } else {
      window.alert('sorry try again')
    }
  }

useEffect(() => {
    Allchallenge()
    const interval = setInterval(() => {
      Allchallenge()
    }, 4000)
    return () => clearInterval(interval)
  }, [])

  if (challenge == undefined) {
    return null
  }

  return loading ? (
    <>
      <div className='App'>
        <div className='item dashboaed_loader'>
          <Loader
            type='bubble-ping'
            bgColor={'#fff'}
            title={<img src={loader} alt='Loading...' />}
            color={'#000'}
            size={100}
          />
        </div>
      </div>
    </>
  ) : (
    <>
      {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
      <div className='row mt-5'>
        <div className='col-12 grid-margin'>
          <div className='card'>
            <div className='card-body table_bg'>
              <h4 className='dashboard_heading'>CONFLICT CHALLANGES</h4>
              <div className='table-responsive'>
                <table className='table' >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th> Creator</th>
                      <th> Accepter</th>
                      <th> Amount </th>
                      <th> Room Code </th>
                      <th> Status </th>
                      <th> Game Type </th>
                      <th>Date</th>
                      <th> Action </th>
                    </tr>
                  </thead>

                  <tbody>
                    {challenge &&
                      challenge.map((game, key) => (
                        <tr key={key} style={{ backgroundColor: game.Red_zone ? "red" : "transparent" }}>
                          <audio src={playSound} autoPlay></audio>9
                          <td>{key + 1}</td>
                          <td>
                            <Link
                              className='btn btn-sm btn-outline-info'
                              to={`/view/${game._id}`}
                            >
                              {game.Created_by?.Red_zone == true ?
                                <span className='pl-2 text-danger'>
                                  {game.Created_by ? game.Created_by.Name : null}
                                </span> :
                                <span className='pl-2'>
                                  {game.Created_by ? game.Created_by.Name : null}
                                </span>
                              }
                            </Link>
                          </td>

                          <td>
                            {
                              game.Accepetd_By?.Red_zone == true ?
                                <span className='pl-2 text-danger'>
                                  {game.Accepetd_By ? game.Accepetd_By.Name : null}
                                </span>
                                :
                                <span className='pl-2'>
                                  {game.Accepetd_By ? game.Accepetd_By.Name : null}
                                </span>
                            }
                          </td>
                          {userData.user_type == 'Admin' ||
                            pdata.legalData == true ? (
                            <td>{game.Game_Ammount}</td>
                          ) : (
                            <td> "" </td>
                          )}
                          <td>{game.Room_code}</td>
                          <td className={`font-weight-bold ${new Date() >= new Date(game.updatedAt).getTime() + Setting?.conflictRedTime * 60 * 1000 ? 'text-danger' : 'text-primary'}`}>
                            {game.Status}
                          </td>

                          <td>{game.Game_type}</td>
                          <td>{dateFormat(game.updatedAt)} </td>
                          <td>
                            {
                              userData.user_type == 'Admin' || pdata.challengesRed === true ||
                                (game.Status == 'conflict' && new Date() <= new Date(game.updatedAt).getTime() + 3 * 60 * 1000)
                                ? <Link type='button' className='btn btn-primary mx-1' to={`/view/${game._id}`}>View</Link>
                                : null
                            }
                          </td>


                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
